// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as MarketRouteImport } from './routes/market'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CreateRouteImport } from './routes/create'
import { Route as CollectionsRouteImport } from './routes/collections'
import { Route as Admincontrol2026RouteImport } from './routes/admincontrol2026'
import { Route as ActivityRouteImport } from './routes/activity'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DropIdRouteImport } from './routes/drop.$id'

const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const MarketRoute = MarketRouteImport.update({
            id: '/market',path: '/market',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const CreateRoute = CreateRouteImport.update({
            id: '/create',path: '/create',getParentRoute: () => rootRouteImport
          })
const CollectionsRoute = CollectionsRouteImport.update({
            id: '/collections',path: '/collections',getParentRoute: () => rootRouteImport
          })
const Admincontrol2026Route = Admincontrol2026RouteImport.update({
            id: '/admincontrol2026',path: '/admincontrol2026',getParentRoute: () => rootRouteImport
          })
const ActivityRoute = ActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DropIdRoute = DropIdRouteImport.update({
            id: '/drop/$id',path: '/drop/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ActivityRoute: ActivityRoute,Admincontrol2026Route: Admincontrol2026Route,CollectionsRoute: CollectionsRoute,CreateRoute: CreateRoute,DashboardRoute: DashboardRoute,MarketRoute: MarketRoute,SecurityRoute: SecurityRoute,TermsRoute: TermsRoute,DropIdRoute: DropIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)